import type { Mode } from "./formats";

const UPPERCASE = 65;
const LOWERCASE = 97;

// Non-letters are passed through and do not advance the key, which is how every published table of the cipher reads.
export function vigenere(text: string, variant: string, key: string, mode: Mode): string {
  const stream = keyStream(key);
  let index = 0;
  let out = "";

  for (const char of text) {
    const base = char >= "A" && char <= "Z" ? UPPERCASE : char >= "a" && char <= "z" ? LOWERCASE : 0;
    if (base === 0) {
      out += char;
      continue;
    }
    const value = char.charCodeAt(0) - base;
    // Autokey grows the stream by a letter for every letter it takes from it, so the index never runs off the end.
    const shift = stream[index % stream.length];
    index++;
    // Beaufort subtracts the text from the key rather than adding, which makes it its own inverse the way ROT13 is.
    const result = variant === "beaufort"
      ? (shift - value + 26) % 26
      : mode === "encode"
      ? (value + shift) % 26
      : (value - shift + 26) % 26;
    if (variant === "autokey") stream.push(mode === "encode" ? value : result);
    out += String.fromCharCode(base + result);
  }
  return out;
}

// A keyword is read for its letters alone, so a phrase with spaces and punctuation in it is the keyword it spells.
function keyStream(key: string): number[] {
  const letters = key.toUpperCase().replace(/[^A-Z]/g, "");
  if (letters === "") throw new Error("The Vigenère key must contain at least one letter");
  return Array.from(letters, (char) => char.charCodeAt(0) - UPPERCASE);
}
